import { RangePickerProps } from "antd/es/date-picker";
import { Moment } from "moment";

export const disabledDateBefore: (
  date: Moment
) => RangePickerProps["disabledDate"] = (before: Moment) => (current) =>
  current && current > before;
